export default __webpack_public_path__ + "static/media/icon_rocket_vector.f43898b2.svg";